import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import s from './checkbox.module.scss';
export var Checkbox = function (_a) {
    var checked = _a.checked, onChange = _a.onChange, label = _a.label;
    return (_jsxs("label", { className: s.wrapper, children: [_jsx("input", { type: 'checkbox', checked: checked, onChange: onChange, className: s.input }), _jsx("span", { className: s.checkbox }), label && _jsx("span", { className: s.label, children: label })] }));
};
